import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable complexity */
/* eslint-disable max-lines */
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { createUseStyles } from 'react-jss';
import { generateUniqueId } from '../../../../utils/ComponentUtils';
import FormErrorText from '../../FormErrorText';
import FormHelpText from '../../FormHelpText';
import FormLabel from '../../FormLabel';
import withMemo from '../../../../decorators/withMemo';
import { mergeStyles } from '../../../../utils/StyleUtils';
import styles from './styles';
var useStyles = createUseStyles(styles);
function Text(props) {
  var className = props.className,
    inputClassName = props.inputClassName,
    type = props.type,
    id = props.id,
    name = props.name,
    value = props.value,
    label = props.label,
    help = props.help,
    placeholder = props.placeholder,
    required = props.required,
    disabled = props.disabled,
    error = props.error,
    maxChar = props.maxChar,
    inputRef = props.inputRef,
    endOrnament = props.endOrnament,
    startOrnament = props.startOrnament,
    readOnly = props.readOnly,
    inputProps = props.inputProps,
    onChange = props.onChange,
    onBlur = props.onBlur,
    onFocus = props.onFocus,
    classesProp = props.classes;
  var _useState = useState("form_text_".concat(generateUniqueId())),
    _useState2 = _slicedToArray(_useState, 1),
    thisId = _useState2[0];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var handleChange = function handleChange(event) {
    if (inputProps && inputProps.onChange) {
      inputProps.onChange(event);
    }
    onChange({
      name: name,
      value: event.currentTarget.value,
      event: event
    });
  };
  var handleFocus = function handleFocus(event) {
    setFocused(true);
    if (inputProps && inputProps.onFocus) {
      inputProps.onFocus(event);
    }
    onFocus({
      name: name,
      event: event
    });
  };
  var handleBlur = function handleBlur(event) {
    setFocused(false);
    if (inputProps && inputProps.onBlur) {
      inputProps.onBlur(event);
    }
    onBlur({
      name: name,
      event: event
    });
  };
  var classesComp = useStyles(_objectSpread(_objectSpread({}, props), {}, {
    focused: focused
  }));
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(classes.container, className)
  }, /*#__PURE__*/React.createElement(React.Fragment, null, label !== '' && /*#__PURE__*/React.createElement("label", {
    className: classes.label,
    htmlFor: id || thisId
  }, /*#__PURE__*/React.createElement(FormLabel, {
    className: classes.formLabel,
    required: required,
    error: !!error
  }, label), /*#__PURE__*/React.createElement(FormHelpText, {
    className: classes.helpText,
    text: help,
    error: !!error
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.inputContainer
  }, startOrnament && /*#__PURE__*/React.createElement("div", {
    className: cx(classes.ornament, classes.startOrnament)
  }, startOrnament), /*#__PURE__*/React.createElement("input", _extends({}, inputProps, {
    id: id || thisId,
    ref: inputRef,
    className: cx(classes.input, inputClassName),
    type: type,
    name: name,
    "aria-label": name,
    value: value,
    required: required,
    disabled: disabled,
    readOnly: readOnly,
    maxLength: maxChar,
    onChange: handleChange,
    onBlur: handleBlur,
    onFocus: handleFocus,
    placeholder: placeholder
  })), endOrnament && /*#__PURE__*/React.createElement("div", {
    className: cx(classes.ornament, classes.endOrnament)
  }, endOrnament))), /*#__PURE__*/React.createElement(FormErrorText, {
    className: classes.errorText,
    text: error,
    tag: "label",
    htmlFor: id || thisId
  }));
}
Text.styles = styles;
Text.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  inputClassName: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.oneOf(['email', 'password', 'text', 'number', 'hidden']),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  error: PropTypes.string,
  help: PropTypes.string,
  placeholder: PropTypes.string,
  maxChar: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  inputProps: PropTypes.object,
  onChange: PropTypes.func,
  // {name, value, event}
  onBlur: PropTypes.func,
  // {name, event}
  onFocus: PropTypes.func,
  // {name, event}
  inputRef: PropTypes.func,
  endOrnament: PropTypes.node,
  startOrnament: PropTypes.node
};
Text.defaultProps = {
  classes: {},
  className: null,
  id: null,
  inputClassName: null,
  value: '',
  label: '',
  type: 'text',
  required: false,
  disabled: false,
  readOnly: false,
  error: null,
  help: null,
  placeholder: null,
  maxChar: null,
  inputProps: null,
  onChange: function onChange() {
    return undefined;
  },
  onBlur: function onBlur() {
    return undefined;
  },
  onFocus: function onFocus() {
    return undefined;
  },
  inputRef: function inputRef() {
    return undefined;
  },
  endOrnament: null,
  startOrnament: null
};
export default withMemo()(Text);